import React from 'react';
import PropTypes from 'prop-types';

export function embedMatch(projectId, version, conversationId) {
  return {
    params: {
      projectId: projectId || '',
      version: version || '',
      conversationId: conversationId || '',
    },
    url: '',
    path: '',
    isExact: true,
  };
}

const EmbedFeature = ({ component: Feature, projectId, version, conversationId }) => {
  if (!Feature) return null;
  return (
    <div className="vibe-more-embed">
      <Feature match={embedMatch(projectId, version, conversationId)} embedded />
    </div>
  );
};

EmbedFeature.propTypes = {
  component: PropTypes.elementType,
  projectId: PropTypes.string,
  version: PropTypes.string,
  conversationId: PropTypes.string,
};

export default EmbedFeature;
